//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.HoleMachiningCutParameters.js";
import "../CAM/CAM.FeedsBuilder.js";
import "../CAM/CAM.NcmHoleMachining.js";
import "../CAM/CAM.DimensionRule.js";
let d=[[[0,"CollisionCheck",1,0],[1,"CuttingParameters",0,"CAM.HoleMachiningCutParameters",0],[1,"FeedsBuilder",0,"CAM.FeedsBuilder",0],[1,"NonCuttingBuilder",0,"CAM.NcmHoleMachining",0],[1,"PredefinedDepth",0,"CAM.DimensionRule",0]],[[[],"GetFeatureGeometry",{R_:{featureGeometry:"CAM.FBM.FeatureGeometry"}},0,0],[[],"UnlockFeatures",{},0,0],[[],"RemoveOverrides",{},0,0]],[]];
SPLM.CAM.HoleMachiningBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.HoleMachiningBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;